import { useCallback, useEffect, useState } from "react";

/** O backend aceita um pedido de código por minuto (`auth.account.tooManyRequests`). */
export const CODE_RESEND_COOLDOWN_SECONDS = 60;

export function useResendCooldown(seconds: number = CODE_RESEND_COOLDOWN_SECONDS) {
    const [remaining, setRemaining] = useState(0);

    useEffect(() => {
        if (remaining <= 0) return;
        const timer = window.setTimeout(() => setRemaining((value) => value - 1), 1000);
        return () => window.clearTimeout(timer);
    }, [remaining]);

    const start = useCallback(() => setRemaining(seconds), [seconds]);

    return { remaining, start, coolingDown: remaining > 0 };
}
